/**
 * Whether a work order in the given (job status, work-order status) state may be
 * cancelled by the user.
 *
 * Cancel is a POST-ACCEPTANCE action only. A job still awaiting Accept/Reject
 * (Not Started / New | Reopened) must be Rejected, not Cancelled — so those
 * states are deliberately absent.
 *
 * This predicate MUST mirror the backend OUTBOUND_CANCEL_ALLOWED list
 * (workOrderDirectionalService.ts) so the Cancel button is shown iff the backend
 * would accept the cancel.
 */
const CANCEL_ALLOWED: ReadonlyArray<{ js: string; wos: string }> = [
  { js: 'Accepted', wos: 'Ready for Planning' },
  { js: 'On Hold', wos: 'Duration Challenged' },
  { js: 'Planned', wos: 'Planned' },
  { js: 'In Progress', wos: 'En Route' },
  { js: 'In Progress', wos: 'On Site' },
  { js: 'In Progress', wos: 'Engineering Completed' },
  { js: 'Abort', wos: 'Ready for Planning' },
];

export function canCancelJob(jobStatusName: string, workOrderStatusName: string): boolean {
  return CANCEL_ALLOWED.some((c) => c.js === jobStatusName && c.wos === workOrderStatusName);
}
